import { api, request } from './http';
import type { PageSavePayload, WebsiteResponse } from './types';

export const website = {
  load: (signal?: AbortSignal) => api.get<WebsiteResponse>('/website', signal),
  save: (page: string, body: PageSavePayload) =>
    api.put<{ fields: unknown; seo: unknown; hidden: string[] }>(`/website/${page}`, body),
  /** Returns rendered HTML, not JSON — the preview is a real page. */
  preview: async (body: {
    page: string;
    on?: string;
    fields?: Record<string, string>;
    hidden?: string[];
    /* The bands as the panel has them right now, so the picture beside it
       shows the arrangement being edited rather than the saved one. */
    sections?: Record<string, boolean>;
    order?: string[];
  }) => request<string>('/preview', { method: 'POST', body }),
};
